export const en = {
  antalltimer: "Number of hours",
  ansettelsesform: "Form of employment",
  ansettelsesperiode: "Employment period",
  apne: "Open",
  arbeidsavtale: "Employment",
  arbeidsforhold: "Employment",
  arbeidsforholdid: "Employment ID",
  arbeidstidsordning: "Working scheme",
  endretstillingsprosent: "Changed position percentage",
  fartsomraade: "Area",
  generelleopplysninger: "General information",
  httperror: "Wops, something went wrong when retrieving data!",
  hovedenhet: "Parent company",
  hvisfeil1: `The overview displays employments reported after 01.01.2015.`,
  hvisfeil2: `If something is wrong with the registered information, contact your employer.`,
  ingenarbeidsforhold: `You have no registered employments.`,
  land: "Country",
  lonnsendring: "Salary changed",
  lukke: "Close",
  organisasjonsnummer: "Organization number",
  opptjeningsperiode: "Worked in period",
  navaerendejobb: "Current employment",
  periode: "Period",
  prosent: " Percentage",
  rapporteringsperiode: "Reported in period",
  side: "Page",
  sistbekreftet: "Last confirmed by employer",
  sistelonnsendring: "Last salary change",
  skipsregister: "Ship registry",
  skipstype: "Ship type",
  skrivut: "Print",
  sluttaarsak: "Reason for employment termination",
  stillingsprosent: "Employment percent",
  tabs: {
    arbeidiutlandet: "Work abroad",
    historikk: "History",
    permisjonpermittering: "Leave/Layoff",
    timerfortimelonnet: "Working hours",
  },
  timerifullstilling: "Hours in full position",
  timerperuke: "Hours/week",
  tilleggsopplysninger: "Select what additional information you want to print",
  type: "Type",
  typearbeidsforhold: "Type of employment",
  utskriftsvalg: "Print selection",
  visfaerrearbeidsforhold: "Show fewer",
  visflerearbeidsforhold: "Show more",
  yrke: "Profession",
  pdfFooter1: `The data is reported by employers to the State register of employers and employees`,
  pdfFooter2: (date: string) => `Arbeids- og velferdsetaten // Printed ${date}`,
  ERKONK:
    "End date set by NAV. The employer has gone bankrupt. End date is the same date as the bankruptcy date reported to Konkursregisteret.",
  EROPPH:
    "End date set by NAV. The employer has ceased to exist in Enhetsregisteret. The end date is set to the date the company ceased to exist.",
  ERVIRK:
    "End date set by NAV. The company has been transferred to another legal entity. The end date is set to the date of transfer.",
  IBARBG:
    "End date set by NAV. The employment has not been confirmed. End date is the last date of the calendar month in which the employment is confirmed.",
  IBKAOR:
    "End date set by NAV. The employment has not been confirmed through A-ordningen. End date is set for 31.12.2014",
};
